import { CONSTANT, DEFAULT_CHECKOUT_EXPERIENCE, SDK_IDS, AUTH_DPA_DATA } from '../../utils/constant.js'
import cuid from 'cuid'
import api from '../../actions/api.actions'
import _ from 'lodash'

export default class configurationService {
  dynamicData = ''
  mockSrcEntityIds = [
    {
      mttConfigId: 'MA-VISA_AMEX_START_SRCI',
      index: 2,
      displayName: 'MA -VISA- AMEX - START SRCI',
      environmentId: 'Sandbox',
      srci: [
        {
          srcInitiatorId: '5e6399cf-30c4-4316-8324-93da0c9a80f5',
          type: 'payment',
          legalName: 'MTT Integrated SRCI',
          network: 'MASTERCARD',
          consumerKey: 'WcfNLkjr-0HPnbBjraVrZOQ2RahEPUQoRvFpq_P01c34df46!16962ccc4dc7434f98a76fd5bf3b07e10000000000000000',
          signingKey: {
            status: 0
          },
          encKey: {
            status: 0
          }
        },
        {
          srcInitiatorId: 'PJMHO0GMKYC6G0EKA1D621e-Qhnu2Lnu6N34bN0oOJ-_B06U4',
          type: 'payment',
          legalName: 'START_VISA_SRCI',
          network: 'VISA',
          consumerKey: 'l8mr22kR@yg8cZGe6cmiew6mx6+TDxFu/UFW6TXd',
          signingKey: {
            status: 0
          },
          encKey: {
            status: 0
          }
        },
        {
          srcInitiatorId: 'd1de035f-474e-47bc-89c6-5a073a1ba181',
          type: 'payment',
          legalName: 'START_AMEX_SRCI',
          network: 'AMEX',
          consumerKey: 'test',
          signingKey: {
            status: 0
          },
          encKey: {
            status: 0
          }
        },
        {
          srcInitiatorId: '0f1f3bf9-8b50-4ab0-955a-67b256ce008e',
          type: 'payment',
          legalName: 'START_DISCOVER_SRCI',
          network: 'DISCOVER',
          consumerKey: 'test',
          signingKey: {
            status: 0
          },
          encKey: {
            status: 0
          }
        }
      ],
      dpaConfigs: [
        {
          mttId: 'START_DPA_ID_1',
          displayDpaName: 'START DPA1 - DEBIT TOKEN TRUE',
          dpa: [
            {
              dpaId: '5e6399cf-30c4-4316-8324-93da0c9a80f5_225b1c34-fab3-4096-9523-fe33e28a4452',
              presentationName: 'Mastercard MTT Integrated - DPA 1',
              legalName: 'dpa1_of_MTT Integrated SRCI',
              url: 'http://www.src.com',
              network: 'MASTERCARD'
            },
            {
              dpaId: 'matestdpa7',
              presentationName: 'VISA - START DPA 1',
              legalName: 'VISA matestdpa2',
              url: 'http://www.src.com',
              network: 'VISA'
            },
            {
              dpaId: 'd1de035f-474e-47bc-89c6-5a073a1ba181',
              presentationName: 'AMEX START - DPA 1',
              legalName: 'test',
              url: 'http://www.src.com',
              network: 'AMEX'
            },
            {
              dpaId: 'a8024778-eaed-43f1-9d2f-f9b9b5d84ca8',
              presentationName: 'DISCOVER START - DPA 1',
              legalName: 'test',
              url: 'http://www.src.com',
              network: 'DISCOVER'
            }
          ]
        },
        {
          mttId: 'START_DPA_ID_2',
          displayDpaName: 'START DPA2 - DEBIT TOKEN FALSE',
          dpa: [
            {
              dpaId: '5e6399cf-30c4-4316-8324-93da0c9a80f5_9e3c8b96-2654-4c13-b121-ee40a52338ce',
              presentationName: 'dpa2_of_MTT Integrated SRCI',
              legalName: 'test',
              url: 'http://www.src.com',
              network: 'MASTERCARD'
            },
            {
              dpaId: 'matestdpa7',
              presentationName: 'VISA - START DPA 1',
              legalName: 'VISA matestdpa2',
              url: 'http://www.src.com',
              network: 'VISA'
            },
            {
              dpaId: 'd1de035f-474e-47bc-89c6-5a073a1ba181',
              presentationName: 'AMEX START - DPA 1',
              legalName: 'test',
              url: 'http://www.src.com',
              network: 'AMEX'
            },
            {
              dpaId: 'a8024778-eaed-43f1-9d2f-f9b9b5d84ca8',
              presentationName: 'DISCOVER START - DPA 1',
              legalName: 'test',
              url: 'http://www.src.com',
              network: 'DISCOVER'
            }
          ]
        }
      ]
    }
  ];
  mockDpaIds = [
    {
      mttId: 'START_DPA_ID_1',
      displayDpaName: 'START DPA1 - DEBIT TOKEN TRUE',
      dpa: [
        {
          dpaId: '5e6399cf-30c4-4316-8324-93da0c9a80f5_225b1c34-fab3-4096-9523-fe33e28a4452',
          presentationName: 'Mastercard MTT Integrated - DPA 1',
          legalName: 'dpa1_of_MTT Integrated SRCI',
          url: 'http://www.src.com',
          network: 'MASTERCARD'
        },
        {
          dpaId: 'matestdpa7',
          presentationName: 'VISA - START DPA 1',
          legalName: 'VISA matestdpa2',
          url: 'http://www.src.com',
          network: 'VISA'
        },
        {
          dpaId: 'd1de035f-474e-47bc-89c6-5a073a1ba181',
          presentationName: 'AMEX START - DPA 1',
          legalName: 'test',
          url: 'http://www.src.com',
          network: 'AMEX'
        },
        {
          dpaId: 'a8024778-eaed-43f1-9d2f-f9b9b5d84ca8',
          presentationName: 'DISCOVER START - DPA 1',
          legalName: 'test',
          url: 'http://www.src.com',
          network: 'DISCOVER'
        }
      ]
    },
    {
      mttId: 'START_DPA_ID_2',
      displayDpaName: 'START DPA2 - DEBIT TOKEN FALSE',
      dpa: [
        {
          dpaId: '5e6399cf-30c4-4316-8324-93da0c9a80f5_9e3c8b96-2654-4c13-b121-ee40a52338ce',
          presentationName: 'dpa2_of_MTT Integrated SRCI',
          legalName: 'test',
          url: 'http://www.src.com',
          network: 'MASTERCARD'
        },
        {
          dpaId: 'matestdpa7',
          presentationName: 'VISA - START DPA 1',
          legalName: 'VISA matestdpa2',
          url: 'http://www.src.com',
          network: 'VISA'
        },
        {
          dpaId: 'd1de035f-474e-47bc-89c6-5a073a1ba181',
          presentationName: 'AMEX START - DPA 1',
          legalName: 'test',
          url: 'http://www.src.com',
          network: 'AMEX'
        },
        {
          dpaId: 'a8024778-eaed-43f1-9d2f-f9b9b5d84ca8',
          presentationName: 'DISCOVER START - DPA 1',
          legalName: 'test',
          url: 'http://www.src.com',
          network: 'DISCOVER'
        }
      ]
    }
  ];
  initialConfiguration = {
    isSRCCheckoutDisabled: true,
    environment: CONSTANT.CONFIG.ENVIRONMENT.SANDBOX,
    storefront: {
      quickCart: {
        products: [{
          price: 100,
          quantity: 1,
          productId: cuid()
        }],
        totalPrice: 100.00
      },
      currency: 'USD',
      locale: 'en_US'
    },
    threeDSPreference: null,
    nonPaymentSrci: [],
    checkout: {
      srcId: this.mockSrcEntityIds[0],
      dpaId: this.mockDpaIds[0],
      selectedNonPaymentSrci: null,
      originUrl: this.getOriginUrl(),
      billingAddress: CONSTANT.CONFIG.BILLING_ADDRESS[Object.keys(CONSTANT.CONFIG.BILLING_ADDRESS)[0]],
      shippingAddress: CONSTANT.CONFIG.SHIPPING_ADDRESS[Object.keys(CONSTANT.CONFIG.SHIPPING_ADDRESS)[0]],
      dcfPreference: CONSTANT.CONFIG.DCF_PREFERENCE[Object.keys(CONSTANT.CONFIG.DCF_PREFERENCE)[0]],
      mastercardDcfPreference: CONSTANT.CONFIG.MASTERCARD_DCF_PREFERENCE[Object.keys(CONSTANT.CONFIG.MASTERCARD_DCF_PREFERENCE)[0]],
      amexDcfPreference: CONSTANT.CONFIG.AMEX_DCF_PREFERENCE[Object.keys(CONSTANT.CONFIG.AMEX_DCF_PREFERENCE)[0]],
      visaDcfPreference: CONSTANT.CONFIG.VISA_DCF_PREFERENCE[Object.keys(CONSTANT.CONFIG.VISA_DCF_PREFERENCE)[0]],
      discoverDcfPreference: CONSTANT.CONFIG.DISCOVER_DCF_PREFERENCE[Object.keys(CONSTANT.CONFIG.DISCOVER_DCF_PREFERENCE)[0]],
      confirmPayment: CONSTANT.CONFIG.CONFIRM_PAYMENT_OPTIONS[Object.keys(CONSTANT.CONFIG.CONFIRM_PAYMENT_OPTIONS)[1]],
      checkoutType: CONSTANT.CONFIG.CHECKOUT_TYPE_OPTIONS[Object.keys(CONSTANT.CONFIG.CHECKOUT_TYPE_OPTIONS)[0]],
      shippingCountryCodes: null,
      billingCountryCodes: null,
      payloadTypeIndicatorCheckout: CONSTANT.CONFIG.PAYLOAD_RETRIEVAL_TYPES.PAYMENT,
      payloadTypeIndicatorPayload: CONSTANT.CONFIG.PAYLOAD_RETRIEVAL_TYPES.PAYMENT,
      srcEntityIds: this.mockSrcEntityIds,
      dpaIds: this.mockDpaIds,
      dsaTransactionOptions: {
        consumerNameRequested: true,
        consumerEmailAddressRequested: true,
        consumerPhoneNumberRequested: true
      },
      checkoutMethod: 'direct',
      nationalIdentifier: '',
      consumerBillingAddress: {
        name: '',
        line1: '',
        line2: '',
        line3: '',
        city: '',
        state: '',
        countryCode: '',
        zip: ''
      },
      nationalIdentifierPreference: false,
      encryptedcard: null,
      complianceSettingsObj: {
        complianceResources: [{
          'complianceType': 'PRIVACY_POLICY',
          'uri': 'https://www.mastercard.com/global/click-to-pay/country-listing/privacy.html',
          'version': 'LATEST'
        }],
        privacy: {
          'acceptedVersion': 'LATEST',
          'latestVersion': 'LATEST',
          'latestVersionUri': 'https://www.mastercard.com/global/click-to-pay/country-listing/privacy.html'
        },
        tnc: {
          'acceptedVersion': 'LATEST',
          'latestVersion': 'LATEST',
          'latestVersionUri': 'https://www.mastercard.com/global/click-to-pay/country-listing/terms.html'
        },
        cookie: {
          'acceptedVersion': 'LATEST',
          'latestVersion': 'LATEST',
          'latestVersionUri': 'https://www.mastercard.com/global/click-to-pay/en-us/privacy-notice.html'
        }
      },
      newUser: false,
      enableMPT: false,
      isConsumerAuthModuleEnable: false,
      windowRefType: 'iFrame',
      pflExecutionFlow: 'EMBEDDED',
      selectedCheckoutExperience: DEFAULT_CHECKOUT_EXPERIENCE
    },
    c2pSelectedCurrency: 'USD',
    auth: {
      payloadRequested: null,
      acquirerData: true,
      suppressChallenge: false,
      authPreference: false,
      authenticationSubject: 'CARDHOLDER',
      authenticationMethodTypes: {
        '3DS': false,
        'null': false
      },
      b2bAuthLookupReason: {
        'ENROL_FINANCIAL_INSTRUMENT': true,
        'CONSUMER_IDENTITY_VALIDATION': false,
        'AUTHENTICATOR_REGISTRATION': false,
        'TRANSACTION_AUTHENTICATION': false
      }
    },
    jwtOnOff: CONSTANT.CONFIG.JWT_TESTING_ENABLE[Object.keys(CONSTANT.CONFIG.JWT_TESTING_ENABLE)[0]],
    cofOnOff: CONSTANT.CONFIG.COF_TESTING_ENABLE[Object.keys(CONSTANT.CONFIG.COF_TESTING_ENABLE)[0]],
    selectedProductCategory: 'Jackets',
    federatedID: {
      jwtPayload: [
        {
          alg: 'RS256',
          kid: 'test-harness-verification',
          typ: 'JWT+ext.id_token'
        },
        {
          sub: 'cbb2fab0-d8f2-4940-835c-aa329349ae55',
          email_verified: true,
          amr: ['email_otp'],
          iss: 'https://masterpassteststore.com',
          src_email_mask: 'p*****1@mailinator.com',
          phone_number_verified: false,
          src_phone_number_mask: '1(***) ***-*636',
          aud: [
            'https://mastercard.com',
            'https://www.visa.com',
            'https://americanexpress.com',
            'https://src.discover.com'
          ],
          auth_time: 1739533675,
          phone_number: '15552025636',
          exp: 1739534575,
          iat: 1739533675,
          jti: '99841cd0-198d-40cc-9fd6-005a21b71831',
          email: 'prod101@mailinator.com'
        }
      ]
    },
    tokenization: {
      cryptoFormat: [],
      validityPeriodMinutes: 15,
      dynamicCVC2Support: false
    },
    advanced: {
      paymentProcessorUsername: null,
      paymentProcessorPassword: null,
      cofDigitalCardId: '',
      cofSrciTxId: '',
      supportMobileLookup: CONSTANT.CONFIG.MOBILE_SUPPORT_OPTIONS[Object.keys(CONSTANT.CONFIG.MOBILE_SUPPORT_OPTIONS)[1]],
      srcClientId: '',
      enrollMaskCard: {},
      consumerContactInfo: '',
      saveMaskCard: [],
      selectedSavedCardDetails: null,
      selectedBindingDetails: null,
      paymentProcessor: {},
      authResponse: {}
    },
    enableConfirmation: false,
    dynamicDataTypeMastercard: CONSTANT.TOKENIZATION_OPTIONS.MASTERCARD['UCAF - CARD APPLICATION CRYPTOGRAM SHORT FORM'],
    dynamicDataTypeVisa: CONSTANT.TOKENIZATION_OPTIONS.VISA['TAVV - Transaction Authentication Verification Value'],
    dynamicDataTypeAmex: CONSTANT.TOKENIZATION_OPTIONS.AMEX['DTD - CARD SECURITY CODE'],
    dynamicDataTypeDiscover: CONSTANT.TOKENIZATION_OPTIONS.DISCOVER['CARD APPLICATION CRYPTOGRAM LONG FORM'],
    srcNetwork: '',
    srcCorrelationId: '',
    loadedSDKs: ['mastercard', 'visa', 'amex', 'discover'],
    srcTransactionId: '',
    userAccessToken: '',
    consumerJwt: false,
    consumerInfo: {},
    accountType: 'login',
    consumerEmailId: '',
    adminUserName: '',
    rememberMe: false,
    recognitionToken: {},
    enableAuthSDKFlow: false,
    authExecutionFlow: 'SDK_METHODS_FLOW',
    authPresentationStyle: 'POPUP_BASED',
    enableB2bAuthLookupFIDO: false,
    enableB2bAuthenticate: false,
    enableNativeIntegrationFlow: false,
    authDpaData: AUTH_DPA_DATA,
    tavInfo: '',
    scofExecutionFlow: '',
    mdesExecutionFlow: 'B2B_API_FLOW',
    thirdPartyFIDO: false,
    thirdPartyPKI: false,
    pkiFormat: 'none',
    mdesAuthenticateResponse: '',
    scofReturningInfo: '',
    region: 'GLOBAL',
    traceId: null,
    scofLocale: 'en_US',
    scofOtherLocale: '',
    authenticationFactors: '0A02',
    isNTSFlowEnabled: false,
    nativeFlowServiceId: '',
    profileOptOut: false,
    isConsumerPresent: false,
    isIABFlow: false,
    forceChallenge: false,
    enableTokenizationConsent: false,
    complianceSettingsCITObj: {
      complianceSettings: {
        tokenization: {
          cardHolderConsentCaptured: true,
          cardHolderConsentCapturedTimestamp: '2024-10-12T04:08:57.614Z',
          authentication: {
            authenticationPerformed: true
          }
        }
      },
      assuranceData: {
        verificationData: [
          {
            verificationType: 'CARDHOLDER',
            verificationEntity: '05',
            verificationMethod: '01',
            verificationResults: '01',
            verificationTimestamp: '1621368633',
            additionalData: 'eyJhdXRoVHlwZSI6ICIzRFMiLCJhdXRoTWV0YURhdGEiOiB7ImFhdiI6ICJiV1Z5WTJoaGJuUkpaR1Z1ZEdsbWFXVnkifX0=',
            verificationEvents: [
              '02'
            ]
          }
        ]
      }
    },
    enableENCFlow: false
  };

  /**
   * get origin url i.e. windows host and port
   * @returns {string}
   */
  getOriginUrl () {
    let originUrl = window.location.protocol + '//' + window.location.hostname
    if (window.location.port) {
      originUrl += ':' + window.location.port
    }
    return originUrl
  }

  /**
   * Get display name for selected dpa id
   */
  getDisplayName () {
    if (!this.getConfigData().checkout.dpaId) {
      return this.getConfigData().checkout.dpaIds[0].displayDpaName
    }
    return this.getConfigData().checkout.dpaId.displayDpaName || ''
  }

  /**
   * Get list of environments
   * @returns {*|Promise<T | never>}
   */
  getEnvironments () {
    return api.getEnvironments()
  }

  /**
   * Get api config end points based on environment
   * @param environmentId
   * @returns {*|Promise<T | never>}
   */
  getApiEndPoints (environmentId) {
    return api.getApiEndPoints(environmentId)
  }

  getConfirmationData (confirmationData) {
    return api.confirmation(confirmationData)
  }

  getDefaultComplainceObject () {
    return this.initialConfiguration.complianceSettingsCITObj
  }

  /**
   * Get Default config data
   * @returns {dynamicDataTypeAmex: *, enableConfirmation: boolean, advanced: {cofDigitalCardId: string, cofSrciTxId: string, paymentProcessorPassword: null, paymentProcessorUsername: null, checkoutBtnUrl: *}, dynamicDataTypeVisa: *, jwtOnOff: *, dynamicDataTypeMastercard: *, isSRCCheckoutDisabled: null, tokenization: {validityPeriodMinutes: number, dynamicCVC2Support: boolean, cryptoFormat: []}, environment: *, cofOnOff: *, federatedID: {jwtPayload: string}, storefront: {currency: string, locale: string, quickCart: {totalPrice: number, products: {quantity: number, productId: *, price: number}[]}}, checkout: {payloadRetrievalPreference: [*], originUrl: string, srcEntityIds: {srci: *[], dpaConfigs: *[], environmentId: string, mttConfigId: string, displayName: string, index: number}[], shippingAddress: *, billingCountryCodes: null, dsaTransactionOptions: {consumerEmailAddressRequested: boolean, consumerNameRequested: boolean, consumerPhoneNumberRequested: boolean}, billingAddress: *, shippingCountryCodes: null, dpaIds: *[]}}
   */
  getConfigData () {
    try {
      const configDetails = JSON.parse(localStorage.getItem('configDetails'))
      if (typeof configDetails === 'object' && configDetails !== null) {
        return configDetails
      } else {
        return this.initialConfiguration
      }
    } catch (error) {
      console.error('Error parsing JSON data from localStorage:', error)
    }
  }

  /**
   * set config data state
   * @param configState
   */
  setConfigData (configState) {
    localStorage.setItem('configDetails', JSON.stringify(configState))
  }

  /**
   * Get Payment Processors / sdks
   * @returns {configuration.advanced.paymentProcessor|{AMEX, MASTERCARD, VISA}|string}
   */
  getApiConfig () {
    return this.getConfigData().advanced.paymentProcessor
  }

  /**
   * reset all configuration
   * @param state
   */
  resetConfig (state) {
    localStorage.setItem('configDetails', JSON.stringify(state))
  }

  /**
   * Toggle config values to update config state
   * @param value
   * @param array
   * @param preventRemovingLastItem
   */
  toggleArray (value, array, preventRemovingLastItem) {
    let index = array.indexOf(value)
    if (index > -1) {
      if (array.length === 1 && preventRemovingLastItem === true) {
        // don't remove
      } else {
        array.splice(index, 1)
      }
    } else {
      // add to array
      array.push(value)
    }
  }

  /**
   * update total price and update in config state
   * @param products
   * @returns {number}
   */
  updateTotalPrice (products) {
    let totalPrice = 0
    _.each(products, (prod) => {
      totalPrice += (prod.price * prod.quantity)
    })
    return totalPrice
  }

  /**
   * Load SRC config to get srci ids and dpa ids
   * @param environment
   * @returns {*|Promise<T | never>}
   */
  loadSrcConfiguration (environment) {
    return api.getSrcConfiguration(environment)
  }

  /**
   * Get SRC Keys based on environment
   * @param environment
   * @returns {*|Promise<T | never>}
   */
  getSrcKeys (environment) {
    return api.getSrcKeys(environment)
  }

  /**
   * Get selected config data based on environment
   * @returns {string}
   */
  getConfigDataOnEnvironment () {
    return this.getConfigData().environment
  }

  /**
   * Get environment id
   */
  getSelectedEnvironment () {
    if (localStorage.getItem('setEnv')) {
      return localStorage.getItem('setEnv')
    } else {
      return this.getConfigDataOnEnvironment()
    }
  }

  /**
   * Set config data based on environment change
   * @param environment
   */
  setConfigDataOnEnvironment (environment) {
    const data = this.getConfigData()
    data.environment = environment
    this.setConfigData(data)
  }

  /**
   * Get checkout data from config
   * @returns {payloadRetrievalPreference: *[], dpaId: {dpa: *[]}, srcId: {srci: *[], displayName: string}, originUrl: string, shippingAddress: *, billingCountryCodes: null, dsaTransactionOptions: {consumerEmailAddressRequested: boolean, consumerNameRequested: boolean, consumerPhoneNumberRequested: boolean}, billingAddress: *, enrollEncryptedCard: *, shippingCountryCodes: null}
   */
  getCheckoutDetails () {
    return this.getConfigData().checkout
  }

  /**
   * Get Total Price of cart items
   * @returns {number}
   */
  getTotalPrice () {
    return this.getConfigData().storefront.quickCart.totalPrice
  }

  /**
   * Get Network of checkout
   * @returns {string}
   */
  getSrcNetwork () {
    return this.getConfigData().srcNetwork
  }

  /**
   * Get srcCorrelationId for checkout
   * @returns {string}
   */
  getSrcCorrelationId () {
    return this.getConfigData().srcCorrelationId
  }

  /**
   * Get Mastercard srci id
   * @returns {*}
   */
  getMasterCardSrcEntity () {
    if (!this.getConfigData().checkout.srcId) {
      return this.getConfigData().checkout.srcEntityIds[0].srci[0].srcInitiatorId
    }
    return this.getConfigData().checkout.srcId.srci[0].srcInitiatorId
  }

  /**
   * Get Mastercard dpa id
   * @returns {*}
   */
  getMastercardDpaId () {
    if (!this.getConfigData().checkout.dpaId) {
      return this.getConfigData().checkout.dpaIds[0].dpa[0].dpaId
    }
    return this.getConfigData().checkout.dpaId.dpa[0].dpaId
  }

  /**
   * Get Visa dpa id
   * @returns {*}
   */
  getVisaDpaId () {
    if (!this.getConfigData().checkout.dpaId) {
      return this.getConfigData().checkout.dpaIds[0].dpa[1].dpaId
    }
    return this.getConfigData().checkout.dpaId.dpa[1].dpaId
  }

  /**
   * Get Amex Dpa id
   * @returns {*}
   */
  getAmexDpaId () {
    if (!this.getConfigData().checkout.dpaId) {
      return this.getConfigData().checkout.dpaIds[0].dpa[2].dpaId
    }
    return this.getConfigData().checkout.dpaId.dpa[2].dpaId
  }

  /**
   * Get Visa dpa id
   * @returns {*}
   */
  getDiscoverDpaId () {
    if (!this.getConfigData().checkout.dpaId) {
      return this.getConfigData().checkout.dpaIds[0].dpa[3].dpaId
    }
    return this.getConfigData().checkout.dpaId.dpa[3].dpaId
  }

  /**
   * get visa srci id
   * @returns {*}
   */
  getVisaSrcEntity () {
    if (!this.getConfigData().checkout.srcId) {
      return this.getConfigData().checkout.srcEntityIds[0].srci[1].srcInitiatorId
    }
    return this.getConfigData().checkout.srcId.srci[1].srcInitiatorId
  }

  /**
   * Get Amex srci id
   * @returns {*}
   */
  getAmexSrcEntity () {
    if (!this.getConfigData().checkout.srcId) {
      return this.getConfigData().checkout.srcEntityIds[0].srci[2].srcInitiatorId
    }
    return this.getConfigData().checkout.srcId.srci[2].srcInitiatorId
  }

  /**
   * get Discover srci id
   * @returns {*}
   */
  getDiscoverSrcEntity () {
    if (!this.getConfigData().checkout.srcId) {
      return this.getConfigData().checkout.srcEntityIds[0].srci[3].srcInitiatorId
    }
    return this.getConfigData().checkout.srcId.srci[3].srcInitiatorId
  }

  /**
   * get Initiator Id by SDK id
   * @param networkId
   * @returns {string|*}
   */
  getSrcInitiatorId (sdkId = 0, sdkName = false) {
    if (sdkName) {
      sdkId = this.getSdkIdByName(sdkName)
    }
    if (!this.getConfigData().checkout.srcId) {
      return this.getConfigData().checkout.srcEntityIds[0].srci[sdkId].srcInitiatorId
    }
    return this.getConfigData().checkout.srcId.srci[sdkId].srcInitiatorId
  }

  /**
   * Get DPA Id by sdk id
   * @param networkId
   * @returns {string}
   */
  getDpaId (sdkId = 0, sdkName = false) {
    if (sdkName) {
      sdkId = this.getSdkIdByName(sdkName)
    }
    if (!this.getConfigData().checkout.dpaId) {
      return this.getConfigData().checkout.dpaIds[0].dpa[sdkId].dpaId
    }
    return this.getConfigData().checkout.dpaId.dpa[sdkId].dpaId
  }

  getSdkIdByName (sdkName) {
    return Object.keys(SDK_IDS).indexOf(sdkName)
  }

  /**
   * Get encrypted card flag from config
   * @returns {*}
   */
  getEncryptedEnrollCard () {
    return this.getConfigData().checkout.enrollEncryptedCard
  }

  /**
   * gets the user provided validity period minutes
   */
  getValidityPeriodMinutes () {
    return this.getConfigData().tokenization.validityPeriodMinutes
  }

  getPreferredLocale () {
    if (this.getConfigData().storefront.locale === CONSTANT.CONFIG.OTHER_LOCALE) {
      return this.getConfigData().storefront.otherLocale ? this.getConfigData().storefront.otherLocale : ''
    } else {
      return this.getConfigData().storefront.locale
    }
  }

  getScofPreferredLocale () {
    if (this.getConfigData().scofLocale === CONSTANT.CONFIG.OTHER_LOCALE) {
      return this.getConfigData().scofOtherLocale ? this.getConfigData().scofOtherLocale : ''
    } else {
      return this.getConfigData().scofLocale
    }
  }

  /**
   * Get current confirmation button state
   * @returns {string}
   */
  getEnableConfirmation () {
    return this.getConfigData().enableConfirmation
  }

  /**
   * reload callback once after successful checkout
   */
  reloadPage () {
    if (localStorage.getItem('reloaded')) {
      localStorage.removeItem('reloaded')
    } else {
      localStorage.setItem('reloaded', '1')
      location.reload()
    }
  }

  getSrcTransactionId () {
    return this.getConfigData().srcTransactionId
  }

  getBindMfaApiResponse (reqBody, param) {
    return api.getBindMfaApiResponse(reqBody, param)
  }

  getScofPayloadApiResponse (reqBody, param) {
    return api.getScofPayloadApiResponse(reqBody, param)
  }

  getB2BAuthLookupApiResponse (reqBody) {
    return api.getB2BAuthLookupApiResponse(reqBody)
  }

  getTAVGenerateApiResponse (reqBody) {
    return api.getTAVGenerateApiResponse(reqBody)
  }

  getB2BAuthenticateApiResponse (reqBody) {
    return api.getB2BAuthenticateApiResponse(reqBody)
  }

  getCardDetails (reqBody) {
    return api.getCardDetails(reqBody)
  }

  getScofResultApiResponse (reqBody, param) {
    return api.getScofResultApiResponse(reqBody, param)
  }

  async getThirdPartyPKIData (reqBody) {
    return api.getThirdPartyPKIData(reqBody)
  }
}
